import { render, staticRenderFns } from "./UpdateNotifications.vue?vue&type=template&id=4fc8fbb0&scoped=true"
import script from "./UpdateNotifications.vue?vue&type=script&lang=js"
export * from "./UpdateNotifications.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotifications.vue?vue&type=style&index=0&id=4fc8fbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc8fbb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
